import React from 'react'
import PropTypes from 'prop-types'
import { MatchInfo } from '../Screens/MatchData/main.js'

const MatchDataPage = ({ data }) => {
  return <MatchInfo data={data} />
}

MatchDataPage.propTypes = {
  data: PropTypes.object.isRequired
}

export default MatchDataPage
